var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "Thông tin bổ sung",
        "dialog-class": "sk-dialog--lg",
        "use-panel": false,
        "show-cancel": false,
        "show-confirm": false,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleClosed,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("Lưu")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "aid-dialog",
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.formRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "sk-panel aid-dialog__panel" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-user" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thông tin điểm danh bổ sung"),
                      ]),
                      _vm.studentName
                        ? _c("p", { staticClass: "sk-panel-subtitle" }, [
                            _vm._v("Học sinh: " + _vm._s(_vm.studentName)),
                          ])
                        : _vm._e(),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Đợt " +
                            _vm._s(_vm.turn) +
                            " - Tháng " +
                            _vm._s(_vm.month) +
                            "/" +
                            _vm._s(_vm.year)
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "aid-dialog__head" }, [
                    _c("div", [_vm._v("Tiêu đề")]),
                    _c("div", [_vm._v("Tháng " + _vm._s(_vm.month))]),
                    _c("div", [_vm._v(_vm._s(_vm.monthBeforeLabel))]),
                    _c("div", [_vm._v("Bổ sung")]),
                  ]),
                  _vm._l(_vm.metricRows, function (item) {
                    return _c(
                      "div",
                      { key: item.key, staticClass: "aid-dialog__row" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "aid-dialog__cell aid-dialog__cell--title",
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                        _c("div", { staticClass: "aid-dialog__cell" }, [
                          _vm._v(
                            _vm._s(_vm.valueOrZero(_vm.dataForm[item.totalKey]))
                          ),
                        ]),
                        _c("div", { staticClass: "aid-dialog__cell" }, [
                          _vm._v(
                            _vm._s(
                              _vm.valueOrZero(_vm.dataForm[item.monthBeforeKey])
                            )
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "aid-dialog__cell aid-dialog__cell--edit",
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "aid-dialog__form-item",
                                attrs: { prop: item.valueKey },
                              },
                              [
                                _c("el-input-number", {
                                  staticClass: "sk-u-w-full",
                                  attrs: {
                                    min: 0,
                                    step: 1,
                                    size: "small",
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: _vm.dataForm[item.valueKey],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, item.valueKey, $$v)
                                    },
                                    expression: "dataForm[item.valueKey]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "sk-panel aid-dialog__panel sk-u-mt-12" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-document" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Nội dung ghi chú"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Ghi chú hiển thị đồng bộ cho phiếu thu nháp"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Ghi chú", prop: "note" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: "500",
                          "show-word-limit": "",
                          placeholder: "Nhập ghi chú bổ sung",
                        },
                        model: {
                          value: _vm.dataForm.note,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "note", $$v)
                          },
                          expression: "dataForm.note",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }